export const LEGAL_PHONE = '888-621-2001';
export const LEGAL_HELP_EMAIL = 'help@itswoop.com';
export const LEGAL_INFO_EMAIL = 'info@itswoop.com';
